import { Select, Spin, Table, TableColumnsType } from "antd";
import React from "react";
import apiClient from "../../../api/axiosConfig.tsx";
import { LoadingOutlined } from "@ant-design/icons";

const CreateCouponForUser = () => {
  const [loading, setLoading] = React.useState<boolean>(false);
  const [listIndex, setListIndex] = React.useState<any[]>([]);
  const [result, setResult] = React.useState<any[]>([]);

  const [data, setData] = React.useState<any>({
    expire_date: "",
    category: "",
    amount: "",
    title: "",
    description: "",
  });

  const columns: TableColumnsType<any> = [
    {
      title: (
        <div className="flex items-center justify-center max-md:text-sm max-sm:text-xs">
          <span>Cửa hàng</span>
        </div>
      ),
      dataIndex: "EVENT_HDD",
      render: (text: string) => (
        <div>
          <span className="font-semibold text-[pink] max-sm:text-xs">
            {text}
          </span>
        </div>
      ),
    },
    {
      title: (
        <div className="flex items-center justify-center max-md:text-sm max-sm:text-xs">
          <span>Mã</span>
        </div>
      ),
      dataIndex: "EVENT_POINT",
      render: (text: string) => (
        <div>
          <span className="font-medium max-sm:text-xs">{text}</span>
        </div>
      ),
    },
    {
      title: (
        <div className="flex items-center justify-center max-md:text-sm max-sm:text-xs">
          <span>Loại</span>
        </div>
      ),
      dataIndex: "Category",
      render: (text: string) => (
        <div>
          <span className="font-medium max-sm:text-xs">{text}</span>
        </div>
      ),
    },
    {
      title: (
        <div className="flex items-center justify-center max-md:text-sm max-sm:text-xs">
          <span>Tiền giảm</span>
        </div>
      ),
      dataIndex: "Discount",
      render: (text: string) => (
        <div>
          <span className="font-medium text-[pink] max-sm:text-xs">{text}</span>
        </div>
      ),
    },
    {
      title: (
        <div className="flex items-center justify-center max-md:text-sm max-sm:text-xs">
          <span>Thực trả</span>
        </div>
      ),
      dataIndex: "Amount",
      render: (text: string) => (
        <div>
          <span className="font-medium max-sm:text-xs">{text}</span>
        </div>
      ),
    },
    {
      title: (
        <div className="flex items-center justify-center max-md:text-sm max-sm:text-xs">
          <span>Máy</span>
        </div>
      ),
      dataIndex: "Machine",
      render: (text: string) => (
        <div>
          <span className="font-semibold text-red-600 max-sm:text-xs">
            {text}
          </span>
        </div>
      ),
    },
    {
      title: (
        <div className="flex items-center justify-center max-md:text-sm max-sm:text-xs">
          <span>Trạng thái</span>
        </div>
      ),
      dataIndex: "status",
      render: (text: string) => (
        <div>
          <span className="font-semibold bg-pink-300 text-white rounded-full px-[6px] py-[4px] flex justify-center items-center max-sm:text-xs">
            {text}
          </span>
        </div>
      ),
    },
  ];

  const handleCreateAccount = async () => {
    setLoading(true);
    const dataRequest = {
      ...data,
      phoneNumbers: listIndex,
    };
    console.log("dataRequest======= ", dataRequest);
    const res: any = await apiClient.post(`coupon/user-coupon`, dataRequest);
    console.log("res======= ", res?.data);
    if (res?.status) {
      setLoading(false);
      alert(res?.data?.message || "Thêm coupon thành công");
    } else {
      setLoading(false);
      setResult([]);
      alert(res?.data?.message || "Thêm coupon thất bại");
    }
  };

  const classInput =
    "w-full border-[1px] border-[pink] rounded-md px-2 py-2 outline-none";
  const classLable =
    "md:font-semibold text-[pink] max-md:text-[10px] max-md:mb-3";

  return (
    <div className="w-full">
      <div className="text-2xl text-center text-[pink] font-bold">
        PHÁT COUPON NGƯỜI DÙNG
      </div>
      <div className="mb-3">
        <div className={classLable}>
          Số điện thoại nhận coupon, mỗi số cách nhau bằng dấu "," (ví dụ:
          84369350849,84363073476...)
        </div>
        <input
          onChange={(value) => {
            setListIndex(value.target.value.split(","));
          }}
          type="text"
          className={classInput}
        />
      </div>

      <div className="mb-3">
        <div className={classLable}>Loại coupon</div>
        <Select
          onChange={(e) => {
            setData({
              ...data,
              category: e,
            });
          }}
          size="large"
          className="custom-select w-full text-[pink] border-[pink] rounded-md"
        >
          {["BANBE", "Free", "NEW", "CHECKIN", "STUDENT", "BIRTHDAY"]?.map(
            (item: any) => {
              return (
                <Select.Option key={item} value={item}>
                  {item}
                </Select.Option>
              );
            }
          )}
        </Select>
      </div>

      <div className="mb-3">
        <div className={classLable}>Số tiền</div>
        <Select
          onChange={(e) => {
            setData({
              ...data,
              amount: e,
            });
          }}
          size="large"
          className="custom-select w-full text-[pink] border-[pink] rounded-md"
        >
          {["70000", "100000", "20000", "80000", "110000", "50000"]?.map(
            (item: any) => {
              return (
                <Select.Option key={item} value={item}>
                  {item}
                </Select.Option>
              );
            }
          )}
        </Select>
      </div>

      <div className="mb-3">
        <div className={classLable}>Ngày hết hạn</div>
        <Select
          onChange={(e) => {
            setData({
              ...data,
              expire_date: e,
            });
          }}
          size="large"
          className="custom-select w-full text-[pink] border-[pink] rounded-md"
        >
          {["30", "15", "40"]?.map((item: any) => {
            return (
              <Select.Option key={item} value={item}>
                {item}
              </Select.Option>
            );
          })}
        </Select>
      </div>

      <div className="mb-3">
        <div className={classLable}>Tiêu đề</div>
        <input
          onChange={(value) => {
            setData({
              ...data,
              title: value.target.value,
            });
          }}
          type="text"
          className={classInput}
        />
      </div>

      <div className="mb-3">
        <div className={classLable}>Mô tả</div>
        <input
          onChange={(value) => {
            setData({
              ...data,
              description: value.target.value,
            });
          }}
          type="text"
          className={classInput}
        />
      </div>

      <div className="flex justify-center">
        <button
          className="mb-4 bg-[pink] text-white py-3 px-6 rounded-md"
          onClick={() => {
            handleCreateAccount();
          }}
        >
          {loading ? (
            <Spin
              className="text-white"
              indicator={<LoadingOutlined color="white" spin />}
              size="small"
            />
          ) : (
            "Tạo"
          )}
        </button>
      </div>

      {result?.length > 0 && (
        <div className="w-full">
          <Table
            columns={columns}
            dataSource={result}
            pagination={false}
            rowKey={(record) => record?.EVENT_HDD}
            className="w-full"
          />
        </div>
      )}
    </div>
  );
};

export default CreateCouponForUser;
